import React, { Fragment, useState, useEffect, useContext} from "react";
import { SessionContext } from '../context/sessionContext';

import { Form } from "react-bootstrap";
import DatePicker from "react-datepicker";

import { optionsActorEncargadoObras, optionsJurisdiccionCSP, optionsEstadoTramitacionCSP, optionsSeguimientoCSP } from "../datos/options";

import SelectInput from "./selectInput";

/*
EX 20-09-2026 (fase 2 - paso 5) - FORMULARIO UNICO del Tab 3 ("Caracteristicas y seguimiento del
proyecto" ---> los campos CSP).

Antes habia DOS copias de este formulario: pestana3_Exp.js (alta) y pestana3_EditExp.js (edicion), con
94,1% de similitud en el JSX y 81,2% en la logica. Igual que en el Tab 1 (datosExp.js, paso 3) y en el
Tab 2 (tramiteExp.js, paso 4b), ahora hay UN solo componente y las diferencias que quedan son props de
CAPACIDAD: no hay ningun `modo === 'alta' ? ...`. El default de TODAS las capacidades es el ALTA, asi que
expediente.js no pasa ninguna prop y sigue igual; grupo_editexpediente.js pasa las que necesita.

  precargarDatos                    - la edicion muestra los valores que ya trae `inputsCSP`. Donde el
                                      campo es controlado se pasa `value`, donde es no controlado
                                      `defaultValue` (los SelectInput) y los checkboxes `checked`. Con
                                      false no se pasa NINGUNO de los tres (valorInicial devuelve
                                      undefined). No es lo mismo que pasar un valor vacio: el
                                      value/defaultValue/checked se aplica al montar y el alta no se tiene
                                      que "acordar" de un expediente que se cargo antes.
  evalEnCheckboxesFinanciamiento     - los 3 checks de financiamiento (csp_3 infra, csp_8 viv, csp_13
                                      equip) leen su `checked` con eval(...) en la edicion y con el valor
                                      crudo en el alta. eval(false) === false y eval(true) === true, o sea
                                      que con un booleano guardado las dos formas son identicas; la
                                      diferencia es REAL cuando el valor guardado es el STRING "false",
                                      porque eval("false") da el booleano false mientras que el string
                                      "false" es truthy y React lo tildaria. En la edicion esos tres
                                      valores se arman con eval(...) en grupo_editexpediente.js, asi que
                                      hoy son booleanos; el eval se conserva tal cual (limpiarlo es otro
                                      paso).
  sembrarPlanosEnInputsCSP           - la edicion, al montar, copia el estado `planos` a
                                      inputsCSP.planos si todavia no es un array, para que el guardado
                                      los lleve aunque el usuario no toque ningun plano. El alta NO puede
                                      hacer eso: el body de /api/authentication/new_expediente manda
                                      inputsCSP completo, asi que agregarle una clave `planos` cambiaria
                                      el payload del alta.
  normalizarFechasPrecargadas        - la edicion pasa las fechas ya guardadas (censo, boletos y
                                      tramites) por normalizeDate() antes de darselas a `selected` del
                                      DatePicker, porque llegan como string o como Date invalida y
                                      normalizeDate las lleva a Date local (si no, al recuperar se ve un
                                      dia menos). El alta las pasa crudas, tal como estaban.
  alturaAutoEnColumnasFinanciamiento - las columnas del bloque FINANCIAMIENTO (csp_2, csp_5, csp_7,
                                      csp_10, csp_12, csp_15 y csp_17) llevan style={{height:"auto"}} en
                                      la edicion, y en el alta alturas/margenes fijos (marginTop 23px,
                                      height 126px, minHeight 100px) o ninguno (csp_2). Es una diferencia
                                      de layout, no de datos: se conserva la de cada flujo para no cambiar
                                      el alto de ninguna pantalla en este paso. Unificarla es otro paso.

Las diferencias REALES que resolvio `precargarDatos` son 15 controles:
  - 5 SelectInput que la edicion precargaba con defaultValue y el alta no pasaba nada: csp_2 Actor
    encargado obras, csp_4 Jurisdiccion (infra), csp_9 Jurisdiccion (viv), csp_14 Jurisdiccion (equip) y
    csp_28 Presencia de apertura de calles.
  - 9 textarea: csp_27 (observaciones del seguimiento de los proyectos), csp_5 y csp_7 (organismo y
    descripcion de las obras de infraestructura), csp_10 y csp_12 (organismo y descripcion de viviendas),
    csp_15 y csp_17 (organismo y descripcion de equipamientos), csp_31 (observaciones del seguimiento de
    obras y edificacion) y observaciones_censo.
  - 1 input: csp_29_parc_edificadas.
  Los otros campos que la edicion precarga (csp_1, csp_30, censo.cantidadHogares, los 4 inputs de boletos,
  los 2 de tramites y los 7 inputs de texto de cada plano) ya pasaban value en los DOS flujos, asi que
  quedan con `value={...}` DIRECTO, sin valorInicial: el alta queda igual que estaba y la edicion tambien.
  O sea que valorInicial se usa SOLO donde habia una diferencia real que resolver, igual que en los otros
  dos fusionados. Las 4 fechas de censo/boletos/tramites se resolvieron con normalizarFechasPrecargadas.

Las otras diferencias que se revisaron y NO necesitaron prop:
  - `divVisible`: habia que averiguar si se lee. SI se lee, y esta en LOS DOS flujos: el state (aca, con
    el comentario "//estado para div1" que la edicion no tenia) alimenta el style del div id="div_hidden"
    y lo escribe el useEffect de csp_3. Vivo e identico en los dos.
  - `cambioOriginal(1)`: verificado sobre los dos archivos, los dos llaman cambioOriginal(1) en LOS MISMOS
    9 lugares (sincronizarPlanos, onChange y los 7 handlers de censos, boletos, tramites y observaciones
    de censo). No hay ningun handler donde el alta lo llame y la edicion no. Lo unico que la edicion tiene
    de mas es el effect de sembrarPlanosEnInputsCSP, que llama a setInputsCSP SIN cambioOriginal: se dejo
    asi a proposito, porque agregarlo habilitaria los botones de guardar al montar sin tocar nada.
  - `planos`: la edicion tiene el helper _normalizaPlano y un initializer que ademas mira la prop `planos`
    (el editRegistro.planos que pasa la pantalla de edicion) y, si no hay fuente, siembra el primer plano
    con los campos planos csp_18..csp_26. Se unifico SIN capacidad: en el alta `planosProp` es undefined,
    inputsCSP.planos no existe y csp_18..csp_26 arrancan en ""/null (ver inputsCSP en expediente.js), asi
    que esa siembra da exactamente el mismo objeto que el _planoVacio() del alta (referencia "", estado
    "", partido "", orden "", anio "", fecha null, legajo "", folio "", fecha_registracion null y
    fecha_control null).
  - `(censos || [])`: la edicion tolera censos nulo al mapearlos. En el alta `censos` es siempre un array
    (arranca en useState([{...}]) en expediente.js y los tres setCensos de este componente siempre pasan
    arrays), asi que se adopto la forma de la edicion: es un superconjunto y en el alta no cambia nada.
  - `ref={textAreaObs_csp_31}`: lo pasaba solo la edicion. El ref nunca se lee (.current no se usa en
    ningun flujo), asi que queda pasado siempre: es inerte en el alta.
  - `handleRemoveCenso`: el alta usa censos.filter(...) y la edicion splice sobre una copia. Da el mismo
    resultado (array nuevo), asi que queda la del alta, que es el archivo que sobrevive. Lo mismo en
    handleAddCenso, donde la edicion tenia 3 renglones comentados de mas que no se copiaron.
  - el `eval(e.target.checked)` del onChange de los checkboxes: se conserva tal cual. Es un no-op en los
    dos flujos, porque eval() de un booleano devuelve ese mismo booleano; el problema del string "false"
    esta en la LECTURA del `checked` y eso lo resuelve evalEnCheckboxesFinanciamiento.
  - el estado `partido` (useState(null) + useEffect de partidoDG): existia SOLO en el alta y estaba muerto
    (se escribia y no se leia en ningun lado). Se dejo tal cual en la fusion, para no mezclar pasos, y se
    borro en el paso 6c junto con la prop partidoDG, que solo la usaba ese efecto.

Guard del auto-alto (el mismo bug que el paso 4a): en el onChange de este archivo las dos lineas
`e.target.style.height = ...` estaban dentro del bloque cuya condicion incluye 'select-one', asi que un
<select> recibia un height inline igual a su scrollHeight al elegir una opcion y no se recuperaba nunca.
Quedan envueltas en `if (type === 'textarea' || type === 'text')`, con el comentario que cita el commit
3142f64 del Tab 2 y el 7db2483 del Tab 1.

Limpieza del paso 6c (HECHA): se borro el codigo muerto que la fusion dejo a la vista, verificando que cada
simbolo estuviera muerto en ESTE archivo y no solo en los originales (la fusion cambio quien usa que):
  - los 17 renglones comentados que arrastraba el alta en los mismos campos que ahora precarga
    (//value={csp_5_...}, //defaultValue={csp_4_...} y compania), mas 4 //console.log y un //setOriginal(1);
  - los estados que solo se escribian y nadie leia: `partido`/`setEstadoPartido` con su useEffect, y
    `original` del useContext;
  - los 3 useRef textAreaObs_csp_27/31/36 (se pasaban al textarea y nunca se leia .current), el atributo
    ref= de los tres y el import de useRef, que quedo sin uso;
  - el import de Row y Col de react-bootstrap: no se usan en el JSX de este formulario. El de Fragment SI
    se usa, porque los dos flujos ya devolvian el JSX envuelto en <Fragment>;
  - dos bloques JSX comentados (los <div className="container_left"> de FINANCIAMIENTO DE VIVIENDAS y de
    EQUIPAMIENTOS COMUNITARIOS) y los 3 `let` de los _csp_*, que pasaron a `const`.
  Queda sin tocar, a proposito: el `eval(e.target.checked)` del onChange (es un no-op, ver arriba) y el
  layout de las 7 columnas del financiamiento (es el paso de estilos, no este).
*/

const Pestaña3_Exp = ({
	inputsCSP, setInputsCSP, censos, setCensos, boletos, setBoletos, tramites, setTramites, observaciones_censo, setObservacionesCenso, lotesAdjudicables, setErrorCSP,
	//EX 20-09-2026 (fase 2 - paso 5): `planos` es la lista que la pantalla de edicion tiene en
	//editRegistro (grupo_editexpediente.js la pasa como planos={editRegistro.planos}). El alta no la pasa.
	//Se destructura con otro nombre porque `planos` es tambien el state de los planos de este componente.
	planos: planosProp,
	//EX 20-09-2026 (fase 2 - paso 5): capacidades del flujo de EDICION. El default de TODAS es el ALTA,
	//asi que expediente.js no pasa ninguna y sigue igual (ver el encabezado de arriba).
	precargarDatos = false,
	evalEnCheckboxesFinanciamiento = false,
	sembrarPlanosEnInputsCSP = false,
	normalizarFechasPrecargadas = false,
	alturaAutoEnColumnasFinanciamiento = false
}) => {

	const { cambioOriginal } = useContext(SessionContext);

	//EX 20-09-2026 (fase 2 - paso 5): helper unico de precarga, igual al de datosExp.js y tramiteExp.js.
	//Con precargarDatos = false devuelve undefined, que es lo mismo que NO pasar la prop (value /
	//defaultValue / checked): el alta queda no controlado, como estaba.
	const valorInicial = (valor) => (precargarDatos ? valor : undefined);

	//EX 20-09-2026 (fase 2 - paso 5): helper de la capacidad alturaAutoEnColumnasFinanciamiento. Con false
	//devuelve el style del alta (que en csp_2 es undefined, o sea el div sin atributo style) y con true el
	//style={{ height: "auto" }} de la edicion. Ver el encabezado.
	const estiloColumnaFinanciamiento = (estiloAlta) => (alturaAutoEnColumnasFinanciamiento ? { height: "auto" } : estiloAlta);

	//desctructuring 09-04-22
	//EX 20-09-2026 (fase 2 - paso 5): esta lista era un SUBCONJUNTO de la de la edicion: el alta
	//destructuraba solo lo que usaba. En el componente unico hacen falta los 11 names que solo tenia la
	//edicion (csp_2, csp_4, csp_5, csp_7, csp_9, csp_10, csp_12, csp_14, csp_15, csp_17 y csp_18): los 10
	//primeros porque valorInicial los precarga y csp_18 porque siembra el estado del primer plano cuando no
	//hay ninguna fuente de planos (ver el initializer de `planos`). Quedan activos, como en la edicion.
	const {
		csp_1_tamaño_medio_lotes_residenciales,
		csp_2_actor_encargado_obras_infra,
		csp_3_financiamiento_publico_obras_infra,
		csp_4_jurisdiccion_infra,
		csp_5_organismo_financiamiento_infra,
		csp_6_fecha_control_infra,
		csp_7_descripcion_obras_infra,
		csp_8_financiamiento_publico_obras_viv,
		csp_9_jurisdiccion_viv,
		csp_10_organismo_financiamiento_viv,
		csp_11_fecha_control_viv,
		csp_12_descripcion_obras_viv,
		csp_13_financiamiento_publico_obras_equip,
		csp_14_jurisdiccion_equip,
		csp_15_organismo_financiamiento_equip,
		csp_16_fecha_control_equip,
		csp_17_descripcion_obras_equip,
		csp_18_pl_mensura_estado,
		csp_19_pl_mensura_partido,
		csp_20_pl_mensura_orden,
		csp_21_pl_mensura_año,
		csp_22_pl_mensura_fecha,
		csp_23_registracion_legajo, // 08-08-2022: para poder validar
		csp_24_registracion_folio, // 08-08-2022: para validar
		csp_25_registracion_fecha,
		csp_26_fecha_control,
		csp_27_observaciones_csp,
		csp_28_presencia_apertura_calles,
		csp_29_parc_edificadas,
		csp_30_porcentaje_parc_edificadas,
		csp_31_observ_seguimiento_obras_y_edificacion,
		csp_32_fecha_control_seguimiento_obras
	} = inputsCSP

	//4set2026 - planos de mensura: lista reemplazable (múltiples planos + Referencia) - port desde repo_dpph
	const _pfecha = (v) => {
		if (v === undefined || v === null || v === "") return null;
		if (v instanceof Date) return isNaN(v.getTime()) ? null : v;
		const s = String(v);
		const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
		if (m) { const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])); return isNaN(d.getTime()) ? null : d; }
		const d = new Date(s);
		return isNaN(d.getTime()) ? null : d;
	};
	const _planoVacio = (extra) => ({ referencia: "", estado: "", partido: "", orden: "", anio: "", fecha: null, legajo: "", folio: "", fecha_registracion: null, fecha_control: null, ...(extra || {}) });
	//EX 20-09-2026 (fase 2 - paso 5): _normalizaPlano existia SOLO en la edicion; el alta tenia este mismo
	//mapeo escrito inline adentro del initializer. Campo por campo dan el mismo objeto, asi que queda el
	//helper de la edicion para las dos fuentes.
	const _normalizaPlano = (r) => ({
		referencia: r?.referencia ?? "",
		estado: r?.estado ?? "",
		partido: r?.partido ?? "",
		orden: r?.orden ?? "",
		anio: r?.anio ?? "",
		fecha: _pfecha(r?.fecha),
		legajo: r?.legajo ?? "",
		folio: r?.folio ?? "",
		fecha_registracion: _pfecha(r?.fecha_registracion),
		fecha_control: _pfecha(r?.fecha_control)
	});
	const [planos, setPlanos] = useState(() => {
		//EX 20-09-2026 (fase 2 - paso 5): la fuente de los planos es la de la edicion: primero la prop
		//`planos` (la unica que la pasa es la pantalla de edicion) y despues inputsCSP.planos. En el alta
		//planosProp es undefined, asi que la primera rama nunca entra y esto da lo mismo que antes.
		const fuente = (planosProp && Array.isArray(planosProp) && planosProp.length) ? planosProp
			: (inputsCSP.planos && Array.isArray(inputsCSP.planos) && inputsCSP.planos.length) ? inputsCSP.planos
			: null;
		if (fuente) return fuente.map(_normalizaPlano);
		//EX 20-09-2026 (fase 2 - paso 5): si no hay fuente, la edicion siembra el primer plano con los
		//campos planos csp_18..csp_26 en lugar de con un plano vacio como el alta. No hace falta ninguna
		//capacidad: en el alta esos campos arrancan en ""/null (ver el estado inicial de inputsCSP en
		//expediente.js), asi que esta siembra da exactamente el mismo objeto que _planoVacio().
		return [ _planoVacio({
			estado: csp_18_pl_mensura_estado ?? "", partido: csp_19_pl_mensura_partido ?? "",
			orden: csp_20_pl_mensura_orden ?? "", anio: csp_21_pl_mensura_año ?? "",
			fecha: _pfecha(csp_22_pl_mensura_fecha), legajo: csp_23_registracion_legajo ?? "",
			folio: csp_24_registracion_folio ?? "", fecha_registracion: _pfecha(csp_25_registracion_fecha),
			fecha_control: _pfecha(csp_26_fecha_control)
		}) ];
	});
	const sincronizarPlanos = (nuevos) => {
		setPlanos(nuevos);
		const p0 = nuevos[0] || {};
		cambioOriginal(1);
		setInputsCSP({
			...inputsCSP,
			planos: nuevos,
			csp_18_pl_mensura_estado: p0.estado,
			csp_19_pl_mensura_partido: p0.partido,
			csp_20_pl_mensura_orden: p0.orden,
			csp_21_pl_mensura_año: p0.anio,
			csp_22_pl_mensura_fecha: p0.fecha,
			csp_23_registracion_legajo: p0.legajo === "" || p0.legajo === null ? null : p0.legajo,
			csp_24_registracion_folio: p0.folio === "" || p0.folio === null ? null : p0.folio,
			csp_25_registracion_fecha: p0.fecha_registracion,
			csp_26_fecha_control: p0.fecha_control
		});
	};
	const cambiarPlano = (idx, campo, valor) => {
		const nuevos = planos.map((pl, i) => (i === idx ? { ...pl, [campo]: valor } : pl));
		sincronizarPlanos(nuevos);
	};
	const agregarPlano = () => sincronizarPlanos([...planos, _planoVacio()]);
	const quitarPlano = (idx) => { if (planos.length > 1) sincronizarPlanos(planos.filter((_, i) => i !== idx)); };

	//EX 20-09-2026 (fase 2 - paso 5): capacidad sembrarPlanosEnInputsCSP. Esta siembra existia SOLO en la
	//edicion: al montar copia el estado `planos` a inputsCSP.planos para que el guardado los lleve aunque
	//el usuario no toque ningun plano. En el alta no se puede correr: el body del POST a
	//api/authentication/new_expediente manda inputsCSP entero y le agregaria una clave `planos` que hoy
	//no manda, o sea que le cambiaria el payload. Tampoco llama a cambioOriginal(1), igual que la edicion:
	//hacerlo habilitaria los botones de guardar sin que el usuario toque nada.
	useEffect(() => {
		if (!sembrarPlanosEnInputsCSP) {
			return;
		}

		if (!Array.isArray(inputsCSP.planos)) {
			setInputsCSP({ ...inputsCSP, planos });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const [mensajeError, setMensajeError]=useState();

	useEffect(()=>{

		if(csp_29_parc_edificadas === null){
			return
		} else if(csp_29_parc_edificadas !== "" | csp_29_parc_edificadas !== null){

			if(csp_29_parc_edificadas > Number(lotesAdjudicables) ){
				setMensajeError(true)
				setInputsCSP({ ...inputsCSP, "csp_30_porcentaje_parc_edificadas": 0 })
				setErrorCSP(true);

			} else {

				setMensajeError(false)
				let porcentaje = null;
				let a = csp_29_parc_edificadas * 100;
				let b = lotesAdjudicables;
				let resto = a % b;
				if(resto === 0){
					porcentaje = parseFloat((csp_29_parc_edificadas * 100) / Number(lotesAdjudicables));
				} else {
					porcentaje = parseFloat((csp_29_parc_edificadas * 100) / Number(lotesAdjudicables)).toFixed(2);
				}
				setInputsCSP({ ...inputsCSP, "csp_30_porcentaje_parc_edificadas": porcentaje })
				setErrorCSP(false);

			}				
		}		
	}, [csp_29_parc_edificadas, lotesAdjudicables])


	//**CONTADOR OBSERV Generales 03-08-22
	const [maxObserv_27, setMaxObserv_27] = useState(500);
	const [maxObserv_31, setMaxObserv_31] = useState(500);

	useEffect(()=>{
		let max = 500;
		if(csp_27_observaciones_csp){
			if(csp_27_observaciones_csp !== "" || csp_27_observaciones_csp !== null){
				var restantesObs = max - csp_27_observaciones_csp.length;
				setMaxObserv_27(restantesObs);
			}
		} else {
			setMaxObserv_27(max);
		}
	}, [csp_27_observaciones_csp]);
	//---CIERRA-----

	//CONTADOR Observ seguimientos de obras - CSP
	useEffect(()=>{
		let max = 500;
		if(csp_31_observ_seguimiento_obras_y_edificacion){
			if(csp_31_observ_seguimiento_obras_y_edificacion!=="" || csp_31_observ_seguimiento_obras_y_edificacion !==null){
				let restantesObs = max - csp_31_observ_seguimiento_obras_y_edificacion.length;
				setMaxObserv_31(restantesObs);
			}
		} else {
			setMaxObserv_31(max)
		}
	}, [csp_31_observ_seguimiento_obras_y_edificacion])
	//---cierra contador CSP---

	//CONTADOR Observaciones de censo
	const [maxObservCenso_36, setMaxObservCenso_36] = useState(500);
	useEffect(()=>{
		let max = 500;
		if(observaciones_censo){
			if(observaciones_censo!=="" || observaciones_censo!==null){
				let restantesObs = max - observaciones_censo.length;
				setMaxObservCenso_36(restantesObs);
			}
		} else {
			setMaxObservCenso_36(max)
		}
	}, [observaciones_censo])
	//---cierra contador Observaciones de censo---

	//*********ocultar div *****
	const [divVisible, setDivVisible]=useState(false);//estado para div1
	const [divVisible2, setDivVisible2]=useState(false);//estado para div2 ---> csp_8_financiamiento_publico_obras_viv
	const [divVisible3, setDivVisible3]=useState(false);//estado para div3 ---> csp_13_financiamiento_publico_obras_equip


	useEffect(()=>{
			if(csp_3_financiamiento_publico_obras_infra === null || csp_3_financiamiento_publico_obras_infra === false || csp_3_financiamiento_publico_obras_infra === "false"){
				setDivVisible(false)
			} else {
				setDivVisible(true)
			}
	}, [csp_3_financiamiento_publico_obras_infra]);

	useEffect(()=>{
		if(csp_8_financiamiento_publico_obras_viv === null || csp_8_financiamiento_publico_obras_viv === false || csp_8_financiamiento_publico_obras_viv === "false"){
			setDivVisible2(false)
		} else {
			setDivVisible2(true)
		}
	}, [csp_8_financiamiento_publico_obras_viv]);

	useEffect(()=>{
		if(csp_13_financiamiento_publico_obras_equip === null || csp_13_financiamiento_publico_obras_equip === false || csp_13_financiamiento_publico_obras_equip === "false"){
			setDivVisible3(false)
		} else {
			setDivVisible3(true)
		}
	}, [csp_13_financiamiento_publico_obras_equip]);

	//--------cierra ocultar div---


	//EX 20-09-2026 (fase 2 - paso 5): capacidad evalEnCheckboxesFinanciamiento. Estos 3 locales existian
	//SOLO en la edicion y alimentan el `checked` de los 3 checks de financiamiento (csp_3 infra, csp_8 viv,
	//csp_13 equip). El alta le pasaba a `checked` el valor crudo de inputsCSP. eval(false) === false y
	//eval(true) === true, o sea que con un booleano guardado las dos formas coinciden; la diferencia es
	//REAL cuando el valor guardado es el STRING "false", porque eval("false") da el booleano false mientras
	//que el string "false" es truthy y React lo tildaria. Con la capacidad en false cada local queda con el
	//valor crudo y no se llama a eval: es exactamente lo que hacia el alta.
	const _csp_3_financiamiento_publico_obras_infra = evalEnCheckboxesFinanciamiento ? eval(csp_3_financiamiento_publico_obras_infra) : csp_3_financiamiento_publico_obras_infra;

	const _csp_8_financiamiento_publico_obras_viv = evalEnCheckboxesFinanciamiento ? eval(csp_8_financiamiento_publico_obras_viv) : csp_8_financiamiento_publico_obras_viv;
	const _csp_13_financiamiento_publico_obras_equip = evalEnCheckboxesFinanciamiento ? eval(csp_13_financiamiento_publico_obras_equip) : csp_13_financiamiento_publico_obras_equip;

	const onChange = e => {
		cambioOriginal(1);

		const {name, value, type} = e.target;

		if(type === 'textarea' || type === 'text' || type === 'select-one' ){
			if(e.target.name === "csp_1_tamaño_medio_lotes_residenciales") {
				const result = e.target.value.replace(/\D/g, '');
				setInputsCSP({ ...inputsCSP, "csp_1_tamaño_medio_lotes_residenciales" : result });
			} else if(e.target.name === "csp_19_pl_mensura_partido"){
				const result = e.target.value.replace(/\D/g, '');
				setInputsCSP({ ...inputsCSP, "csp_19_pl_mensura_partido" : result });
			} else if(e.target.name === "csp_20_pl_mensura_orden"){
				const result = e.target.value.replace(/\D/g, '');
				setInputsCSP({ ...inputsCSP, "csp_20_pl_mensura_orden" : result });
			} else if( e.target.name === "csp_21_pl_mensura_año"){
				const result = e.target.value.replace(/\D/g, '');
				setInputsCSP({ ...inputsCSP, "csp_21_pl_mensura_año" : result });

			} else if(e.target.name === "csp_23_registracion_legajo"){
				//setValLegajo((v) => (e.target.validity.valid ? e.target.value : v))
				//https://bobbyhadz.com/blog/react-only-number-input
				//https://thewebdev.info/2021/09/26/how-to-only-allow-numbers-to-be-entered-in-an-input-in-react/
				const result = e.target.value.replace(/\D/g, '');
				setInputsCSP({ ...inputsCSP, "csp_23_registracion_legajo" : result });

			} else if(e.target.name === "csp_24_registracion_folio"){

				const result = e.target.value.replace(/\D/g, '');
				setInputsCSP({ ...inputsCSP, "csp_24_registracion_folio" : result });

			} else {//Acá entra por ejemplo csp_27_observaciones_csp y csp_31_observ_seguimiento_obras_y_edificacion

				setInputsCSP({ ...inputsCSP, [name]: value });
			} //----> NO OLVIDAR DESCOMENTAR
			
			//EX 20-09-2026 (fase 2 - paso 5): el auto-alto es SOLO para los textarea y los input de texto.
			//Estaba dentro del bloque que tambien atiende a los selects ('select-one'), y un <select> tiene
			//e.target.type === 'select-one': al elegir una opcion le escribia un height INLINE igual a su
			//scrollHeight, pisando el height que pone SelectInput, y no se recuperaba nunca (React no vuelve
			//a escribir el estilo si el objeto es igual al anterior). Es el mismo bug que ya se arreglo en
			//el Tab 2 (commit 3142f64) y antes en el Tab 1 (commit 7db2483).
			if(type === 'textarea' || type === 'text'){
				e.target.style.height = 'auto';
				e.target.style.height = `${e.target.scrollHeight}px`;
			}

		} else if(type === 'number'){
			if(name === "csp_29_parc_edificadas" || name === "csp_30_porcentaje_parc_edificadas"){
				let value_valid=e.target.value;
				let name_valid=e.target.name;

				if(e.target.value ===null || e.target.value===""){
					value_valid=0;
				}
				setInputsCSP({ ...inputsCSP, [name_valid]: value_valid });

			} else {
				setInputsCSP({ ...inputsCSP, [name]: e.target.value });
			}

		} else if (e.target.type === 'checkbox') {
			setInputsCSP({ ...inputsCSP, [name]: e.target.checked });
		}
	}
	
	const handleChangeDate = (item)=>{
		cambioOriginal(1);
		const fecha = item.value;
		setInputsCSP({ ...inputsCSP, [item.name]: fecha });
	}

	//EX 20-09-2026 (fase 2 - paso 5): normalizeDate existia SOLO en la edicion. Es la funcion que la
	//edicion usa (ver su comentario original "para usar el DataPicker en la propiedad selected / VER
	//problema fechas: al recuperar mostrar un dia menos") para llevar a Date local las fechas que llegan
	//guardadas como string YYYY-MM-DD o como Date invalida. Se copia tal cual, sin tocarle nada.
	const normalizeDate = (date) => {
		if (!date) return new Date(); // Si no hay fecha, devuelve la fecha actual
		
		// Si ya es un objeto Date, devuélvelo
		if (date instanceof Date) {
			// Asegurarse de que no sea una fecha inválida
			return isNaN(date.getTime()) ? new Date() : date;
		}
		
		// Si es string, manejar la fecha correctamente
		if (typeof date === 'string') {
			// Si es solo fecha (formato YYYY-MM-DD), agregar la hora local
			if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
				// Crear la fecha en la zona horaria local
				const [year, month, day] = date.split('-').map(Number);
				return new Date(year, month - 1, day);
			}
			// Si ya tiene hora, convertir normalmente
			return new Date(date);
		}
		
		// Por defecto, devuelve la fecha actual
		return new Date();
	};

	//EX 20-09-2026 (fase 2 - paso 5): helper de la capacidad normalizarFechasPrecargadas para las 4
	//fechas que la edicion normaliza (censo.fechaCenso, boletos.ultimaActualizacionBoletos,
	//boletos.fechaEntregaBoletos y tramites.ultimaActualizacionTramites). Con la capacidad en false
	//devuelve el valor crudo, que es exactamente lo que le pasaba el alta a `selected`; con true reproduce
	//la expresion de la edicion, `valor ? normalizeDate(valor) : null`, sin llamar a normalizeDate.
	const fechaPrecargada = (valor) => {
		if (!normalizarFechasPrecargadas) {
			return valor;
		}

		return valor ? normalizeDate(valor) : null;
	};

	const handleCensoChange = (index, field, value) => {
		cambioOriginal(1);
		const newCensos = [...censos];
		newCensos[index][field] = value;
		setCensos(newCensos);
	};

	const handleAddCenso = () => {
		setCensos([...censos, { fechaCenso: null, cantidadHogares: "" }]); //era new Date()
	};

	const handleRemoveCenso = (index) => {
		const newCensos = censos.filter((_, i) => i !== index);
		setCensos(newCensos);
	};

	const handleBoletoDateChange = (item) => {
		cambioOriginal(1);
		const fecha = item.value;
		setBoletos({ ...boletos, [item.name]: fecha });
	}

	const handleBoletoChange = (e) => {
		cambioOriginal(1);
		const { name, value } = e.target;
		setBoletos({
			...boletos,
			[name]: value.slice(0, 4)
		});
	};

	const handleTramiteDateChange = (item) => {
		cambioOriginal(1);
		const fecha = item.value;
		setTramites({ ...tramites, [item.name]: fecha });
	}

	const handleTramiteChange = (e) => {
		cambioOriginal(1);
		const { name, value } = e.target;
		setTramites({
			...tramites,
			[name]: value.slice(0, 4)
		});
	};

	const handleObservacionCensoChange = (e) => {
		cambioOriginal(1);
		const { value } = e.target;
		setObservacionesCenso(value.slice(0, 500));
	};	

	return (
		<Fragment>
			<div className="container_row">
				<div id="csp_col1_1" className="container_div_column">{/*columna1*/}

					<h6 className="mt-4 text-left subtitulos">CARACTERÍSTICAS DEL PROYECTO</h6>

					<div className="container_left">{/*CL-A*/}
						<div className="input-number">
							<input
								title="Tamaño medio de lotes residenciales"
								type="text"
								name="csp_1_tamaño_medio_lotes_residenciales"
								id="id_csp_1"
								inputmode="numeric" pattern="\d*"
								maxLength="4"
								value={csp_1_tamaño_medio_lotes_residenciales}
								onChange={e => onChange(e)}
							/>
							<label alt="Tamaño medio de lotes residenciales" for="id_csp_1">Tamaño medio de lotes residenciales</label>
						</div>{/*cierra ---> input-container */}
					</div>{/*cierra ---> container_left CL-A*/}

					{/* -----PONER MENSURA cambios  ----*/}
					<div className="container_left">
						<h6 className="mt-4 text-left subtitulos">PLANO DE MENSURA Y DIVISION</h6>
					</div>

					{/* -----PLANOS DE MENSURA Y DIVISION (múltiples, port 4set2026) ----*/}
					{planos.map((pl, i) => (
						<div key={i} style={{ border: "1px solid rgb(200,200,200)", borderRadius: "6px", padding: "10px", margin: "8px 0" }}>

							<div className="flex gap-2">{/*Referencia + Estado*/}
								<div className="flex-1">
									<label style={{ color: "rgb(131,131,131)", fontSize: "0.85em" }} className="block mb-1" htmlFor={"pl_ref_" + i}>Referencia</label>
									<input
										id={"pl_ref_" + i}
										title="Referencia"
										type="text"
										maxLength="255"
										className="border border-gray-300 rounded px-2 py-1 w-full"
										value={pl.referencia}
										onChange={(e) => cambiarPlano(i, "referencia", e.target.value)}
									/>
								</div>
								<div className="flex-1">
									<label style={{ color: "rgb(131,131,131)", fontSize: "0.85em" }} className="block mb-1">Estado de la tramitación</label>
									<SelectInput
										name={"pl_estado_" + i}
										id={"pl_est_" + i}
										value={pl.estado}
										onChange={(e) => cambiarPlano(i, "estado", e.target.value)}
										options={optionsEstadoTramitacionCSP}
									/>
								</div>
							</div>

							<div style={{ fontSize: "0.9em", marginTop: "8px", marginBottom: "4px" }}>Número de plano:</div>

							<div className="flex gap-2">
								<div className="flex-1">
									<label style={{ color: "rgb(131,131,131)", fontSize: "0.85em" }} className="block mb-1">Partido</label>
									<input type="text" maxLength="3" inputMode="numeric" pattern="\d*"
										className="border border-gray-300 rounded px-2 py-1 w-full"
										value={pl.partido}
										onChange={(e) => cambiarPlano(i, "partido", e.target.value.replace(/\D/g, ""))} />
								</div>
								<div className="flex-1">
									<label style={{ color: "rgb(131,131,131)", fontSize: "0.85em" }} className="block mb-1">Orden</label>
									<input type="text" maxLength="4" inputMode="numeric" pattern="\d*"
										className="border border-gray-300 rounded px-2 py-1 w-full"
										value={pl.orden}
										onChange={(e) => cambiarPlano(i, "orden", e.target.value.replace(/\D/g, ""))} />
								</div>
								<div className="flex-1">
									<label style={{ color: "rgb(131,131,131)", fontSize: "0.85em" }} className="block mb-1">Año</label>
									<input type="text" maxLength="4" inputMode="numeric" pattern="\d*"
										className="border border-gray-300 rounded px-2 py-1 w-full"
										value={pl.anio}
										onChange={(e) => cambiarPlano(i, "anio", e.target.value.replace(/\D/g, ""))} />
								</div>
								<div className="flex-1">
									<label style={{ color: "rgb(131,131,131)", fontSize: "0.85em" }} className="block mb-1">Fecha</label>
									<DatePicker
										title="Fecha"
										dateFormat="dd/MM/yyyy"
										className="form-control input_data_picker w-full"
										selected={pl.fecha}
										onChange={(date) => cambiarPlano(i, "fecha", date)}
									/>
								</div>
							</div>

							<div style={{ fontSize: "0.9em", marginTop: "8px", marginBottom: "4px" }}>Registración:</div>

							<div className="flex gap-2">
								<div className="flex-1">
									<label style={{ color: "rgb(131,131,131)", fontSize: "0.85em" }} className="block mb-1">Legajo</label>
									<input type="text" maxLength="4" inputMode="numeric" pattern="[0-9]*"
										className="border border-gray-300 rounded px-2 py-1 w-full"
										value={pl.legajo}
										onChange={(e) => cambiarPlano(i, "legajo", e.target.value.replace(/\D/g, ""))} />
								</div>
								<div className="flex-1">
									<label style={{ color: "rgb(131,131,131)", fontSize: "0.85em" }} className="block mb-1">Folio</label>
									<input type="text" maxLength="4" inputMode="numeric" pattern="\d*"
										className="border border-gray-300 rounded px-2 py-1 w-full"
										value={pl.folio}
										onChange={(e) => cambiarPlano(i, "folio", e.target.value.replace(/\D/g, ""))} />
								</div>
								<div className="flex-1">
									<label style={{ color: "rgb(131,131,131)", fontSize: "0.85em" }} className="block mb-1">Fecha de registración</label>
									<DatePicker
										title="Fecha de registración"
										dateFormat="dd/MM/yyyy"
										className="form-control input_data_picker w-full"
										selected={pl.fecha_registracion}
										onChange={(date) => cambiarPlano(i, "fecha_registracion", date)}
									/>
								</div>
								<div className="flex-1">
									<label style={{ color: "rgb(131,131,131)", fontSize: "0.85em" }} className="block mb-1">Fecha de control</label>
									<DatePicker
										title="Fecha de control"
										dateFormat="MM/yyyy"
										className="form-control input_data_picker w-full"
										selected={pl.fecha_control}
										onChange={(date) => cambiarPlano(i, "fecha_control", date)}
									/>
								</div>
							</div>

							{planos.length > 1 && (
								<div className="mt-2 text-right">
									<button type="button" className="text-red-600 hover:text-red-800 text-sm underline" onClick={() => quitarPlano(i)}>Quitar</button>
								</div>
							)}
						</div>
					))}

					<div className="mt-2">
						<button type="button" className="bg-custom-cyan text-white text-sm px-3 py-1.5 rounded-md" onClick={agregarPlano}>＋ Añadir plano</button>
					</div>

					<div className="container_left" style={{ height: "auto" }}>{/*---> container_left*/}
						<div className="input-container">
							<textarea
								title="Observaciones sobre el seguimiento de los proyectos"
								id="id_csp_27"
								type="text"
								maxLength="500"
								name="csp_27_observaciones_csp"
								//EX 20-09-2026 (fase 2 - paso 5): la edicion precargaba este cuadro y el alta
								//no le pasaba ni value ni defaultValue (es la linea comentada de arriba).
								//Con el default precargarDatos = false queda no controlado, igual que antes.
								value={valorInicial(csp_27_observaciones_csp)}
								onChange={e => onChange(e)}
								rows={5}
							/>
							<label alt="Observaciones sobre el seguimiento de los proyectos" for="id_csp_27">Observaciones sobre el seguimiento de los proyectos</label>
							<p align="right" style={{ height: "5px", fontSize: "0.9em" }}>Caracteres restantes: {maxObserv_27}</p>
						</div>
					</div>
					{/* ------ cierra MENSURA -----*/}

				</div>

				<div id="csp_col2_1" className="container_div_column">

					<h6 className="mt-4 text-left subtitulos">FINANCIAMIENTO DE INFRAESTRUCTURAS</h6>

					{/*EX 20-09-2026 (fase 2 - paso 5): esta columna no lleva style en el alta y la edicion le
					    pone height auto (capacidad alturaAutoEnColumnasFinanciamiento).*/}
					<div className="container_left" style={estiloColumnaFinanciamiento(undefined)}>
						<div className="input-container">
							<SelectInput
								label="Actor encargado obras"
								name="csp_2_actor_encargado_obras_infra"
								//EX 20-09-2026 (fase 2 - paso 5): este defaultValue lo pasaba solo la edicion.
								defaultValue={valorInicial(csp_2_actor_encargado_obras_infra)}
								onChange={e => onChange(e)}
								options={optionsActorEncargadoObras}
								className="form-control my-3"
							/>
							<label alt="Actor encargado obras">Actor encargado obras</label>
						</div>
					</div>{/*cierra ---> container_left CL-B*/}

					<div className="container_left" >{/*---> container_left*/}
						<Form.Check type="checkbox">
							{/*EX 20-09-2026 (fase 2 - paso 5): con evalEnCheckboxesFinanciamiento en false este
							    local es el valor crudo de inputsCSP, o sea el `checked` que ya tenia el alta.
							    Ver el comentario de los 3 locales, arriba de onChange.*/}
							<Form.Check.Input name="csp_3_financiamiento_publico_obras_infra" checked={_csp_3_financiamiento_publico_obras_infra} type="checkbox" onChange={e => onChange(e)} />
							<Form.Check.Label>{`Financiamiento público de las obras de infraestructura`}</Form.Check.Label>
						</Form.Check>
					</div>

					<div id="div_hidden" style={divVisible === true ? { display: 'block' } : { display: 'none' }}>

						<div className="container_left">
							<div className="input-container">
								<SelectInput
									placeholder=""
									name="csp_4_jurisdiccion_infra"
									id="id_csp_4_jurisdiccion_infra"
									onChange={e => onChange(e)}
									//EX 20-09-2026 (fase 2 - paso 5): este defaultValue lo pasaba solo la edicion.
									defaultValue={valorInicial(csp_4_jurisdiccion_infra)}
									options={optionsJurisdiccionCSP}
								/>
								<label alt="Jurisdicción" for="id_csp_4_jurisdiccion_infra">Jurisdicción</label>
							</div>
						</div>{/*cierra ---> container_left*/}

						{/*EX 20-09-2026 (fase 2 - paso 5): en el alta esta columna lleva height auto + marginTop
						    23px y la edicion solo height auto (capacidad alturaAutoEnColumnasFinanciamiento).*/}
						<div className="container_left" style={estiloColumnaFinanciamiento({ height: "auto", marginTop: "23px" })}>{/*---> container_left*/}
							<div className="input-container">
								<textarea
									title="Organismo de financiamiento"
									type="text"
									id="id_csp_5_organismo_financiamiento_infra"
									maxLength="500"
									name="csp_5_organismo_financiamiento_infra"
									//EX 20-09-2026 (fase 2 - paso 5): este value lo pasaba solo la edicion.
									value={valorInicial(csp_5_organismo_financiamiento_infra)}
									onChange={e => onChange(e)}
								//className="form-control my-3"
								/>
								<label alt="Organismo de financiamiento" for="id_csp_5_organismo_financiamiento_infra">Organismo de financiamiento</label>
							</div>
						</div>{/*cierra ---> container_left*/}

						<div className="container_left">
							<div className="input-number">
								<DatePicker
									id="dp_control"
									name="csp_6_fecha_control_infra"
									title="Fecha de control"
									dateFormat="dd/MM/yyyy"
									className="form-control input_data_picker"
									selected={csp_6_fecha_control_infra}
									//onChange={handleFecha_CSP6}
									onChange={(date) => handleChangeDate({ name: "csp_6_fecha_control_infra", value: date })}
								/>
								<label alt="Fecha de control" for="dp_control">Fecha de control</label>
							</div>
						</div>

						{/*EX 20-09-2026 (fase 2 - paso 5): idem columna de csp_5 (altura auto + marginTop 23px
						    en el alta, height auto en la edicion).*/}
						<div className="container_left" style={estiloColumnaFinanciamiento({ height: "auto", marginTop: "23px" })}>{/*---> container_left*/}
							<div className="input-container">
								<textarea
									title="Descripción Obras de Infraestructura financiadas"
									type="text"
									id="id_csp_7"
									maxLength="500"
									name="csp_7_descripcion_obras_infra"
									//EX 20-09-2026 (fase 2 - paso 5): este value lo pasaba solo la edicion.
									value={valorInicial(csp_7_descripcion_obras_infra)}
									onChange={e => onChange(e)}
								/>
								<label alt="Descripción Obras de Infraestructura financiadas" for="id_csp_7">Descripción Obras de Infraestructura financiadas</label>
							</div>
						</div>

					</div> {/*cierra id="div_hidden"*/}


					<div className="container_left">{/*---> container_left*/}
						<Form.Check type="checkbox">
							{/*EX 20-09-2026 (fase 2 - paso 5): este local es el valor crudo o el eval(...) segun
							    evalEnCheckboxesFinanciamiento (ver arriba de onChange).*/}
							<Form.Check.Input name="csp_8_financiamiento_publico_obras_viv" checked={_csp_8_financiamiento_publico_obras_viv} type="checkbox" onChange={e => onChange(e)} />
							<Form.Check.Label>{`Financiamiento público de viviendas`}</Form.Check.Label>
						</Form.Check>
					</div>{/*cierra ---> container_left*/}

					<div id="div_hidden2" style={divVisible2 === true ? { display: 'block' } : { display: 'none' }}>
						<div className="container_left">{/*---> container_left*/}
							<div className="input-container">
								<SelectInput
									name="csp_9_jurisdiccion_viv"
									id="id_csp_9"
									onChange={e => onChange(e)}
									//EX 20-09-2026 (fase 2 - paso 5): este defaultValue lo pasaba solo la edicion.
									defaultValue={valorInicial(csp_9_jurisdiccion_viv)}
									options={optionsJurisdiccionCSP}
									className="form-control my-3"
								/>
								<label alt="Jurisdicción" for="id_csp_9">Jurisdicción</label>
							</div>
						</div>{/*cierra ---> container_left*/}

						{/*EX 20-09-2026 (fase 2 - paso 5): idem columna de csp_5 (altura auto + marginTop 23px
						    en el alta, height auto en la edicion).*/}
						<div className="container_left" style={estiloColumnaFinanciamiento({ height: "auto", marginTop: "23px" })}>{/*---> container_left*/}
							<div className="input-container">
								<textarea
									title="Organismo de financiamiento"
									type="text"
									id="id_csp_10"
									maxLength="500"
									name="csp_10_organismo_financiamiento_viv"
									//EX 20-09-2026 (fase 2 - paso 5): este value lo pasaba solo la edicion.
									value={valorInicial(csp_10_organismo_financiamiento_viv)}
									onChange={e => onChange(e)}
								//className="form-control my-3"
								/>
								<label alt="Organismo de financiamiento" for="id_csp_10">Organismo de financiamiento</label>
							</div>
						</div>{/*cierra ---> container_left*/}

						<div className="container_left">
							<div className="input-number">
								<DatePicker
									id="id_csp_11"
									title="Fecha de control"
									name="csp_11_fecha_control_viv"
									dateFormat="dd/MM/yyyy"
									className="form-control input_data_picker"
									selected={csp_11_fecha_control_viv}
									onChange={(date) => handleChangeDate({ name: "csp_11_fecha_control_viv", value: date })}
								/>
								<label alt="Fecha de control" for="id_csp_11">Fecha de control</label>
							</div>
						</div>{/*cierra container_left NUEVO */}

						{/*EX 20-09-2026 (fase 2 - paso 5): en el alta esta columna lleva minHeight 100px +
						    height auto + marginTop 23px y la edicion solo height auto
						    (capacidad alturaAutoEnColumnasFinanciamiento).*/}
						<div className="container_left" style={estiloColumnaFinanciamiento({ minHeight: "100px", height: "auto", marginTop: "23px" })}>{/*---> container_left*/}
							<div className="input-container">
								<textarea
									title="Descripción obras de infraestructura financiadas"
									type="text"
									id="id_csp_12"
									maxLength="500"
									name="csp_12_descripcion_obras_viv"
									//EX 20-09-2026 (fase 2 - paso 5): este value lo pasaba solo la edicion.
									value={valorInicial(csp_12_descripcion_obras_viv)}
									onChange={e => onChange(e)}
								/>
								<label alt="Descripción obras de infraestructura financiadas" for="id_csp_12">Descripción Obras de Infraestructura financiadas</label>
							</div>
						</div>{/*cierra container_left NUEVO */}
					</div>{/*cierra ---> div_hidden2*/}


					<div className="container_left">{/*---> container_left*/}
						<Form.Check type="checkbox">
							{/*EX 20-09-2026 (fase 2 - paso 5): este local es el valor crudo o el eval(...) segun
							    evalEnCheckboxesFinanciamiento (ver arriba de onChange).*/}
							<Form.Check.Input name="csp_13_financiamiento_publico_obras_equip" checked={_csp_13_financiamiento_publico_obras_equip} type="checkbox" onChange={e => onChange(e)} />
							<Form.Check.Label>{`Financiamiento público de equipamientos comunitarios`}</Form.Check.Label>
						</Form.Check>
					</div>{/*cierra ---> container_left*/}

					<div id="div_hidden3" style={divVisible3 === true ? { display: 'block' } : { display: 'none' }}>
						<div className="container_left">{/*---> container_left*/}
							<div className="input-container">
								<SelectInput
									name="csp_14_jurisdiccion_equip"
									id="id_csp_14"
									onChange={e => onChange(e)}
									//EX 20-09-2026 (fase 2 - paso 5): este defaultValue lo pasaba solo la edicion.
									defaultValue={valorInicial(csp_14_jurisdiccion_equip)}
									options={optionsJurisdiccionCSP}
									className="form-control my-3"
								/>
								<label alt="Jurisdicción" for="id_csp_14">Jurisdicción</label>
							</div>
						</div>{/*cierra ---> container_left*/}

						{/*EX 20-09-2026 (fase 2 - paso 5): en el alta esta columna lleva height 126px +
						    marginTop 23px y la edicion solo height auto
						    (capacidad alturaAutoEnColumnasFinanciamiento).*/}
						<div className="container_left" style={estiloColumnaFinanciamiento({ height: "126px", marginTop: "23px" })}>{/*---> container_left*/}
							<div className="input-container">
								<textarea
									title="Organismo de financiamiento"
									type="text"
									name="csp_15_organismo_financiamiento_equip"
									id="id_csp_15"
									maxLength="500"
									//EX 20-09-2026 (fase 2 - paso 5): este value lo pasaba solo la edicion.
									value={valorInicial(csp_15_organismo_financiamiento_equip)}
									onChange={e => onChange(e)}
								//className="form-control my-3"
								/>
								<label alt="Organismo de financiamiento" for="id_csp_15">Organismo de financiamiento</label>
							</div>
						</div>{/*cierra ---> container_left*/}

						<div className="container_left">
							<div className="input-number">
								<DatePicker
									id="id_csp_16"
									title="Fecha de control"
									name="csp_16_fecha_control_equip"
									dateFormat="dd/MM/yyyy"
									className="form-control input_data_picker"
									selected={csp_16_fecha_control_equip}
									onChange={(date) => handleChangeDate({ name: "csp_16_fecha_control_equip", value: date })}
								/>
								<label alt="Fecha de control" for="id_csp_16">Fecha de control</label>
							</div>
						</div>{/*cierra container_left NUEVO */}

						{/*EX 20-09-2026 (fase 2 - paso 5): idem columna de csp_15 (height 126px + marginTop
						    23px en el alta, height auto en la edicion).*/}
						<div className="container_left" style={estiloColumnaFinanciamiento({ height: "126px", marginTop: "23px" })}>{/*---> container_left*/}
							<div className="input-container">
								<textarea
									title="Descripción obras de infraestructura financiadas"
									type="text"
									id="id_csp_17"
									maxLength="500"
									name="csp_17_descripcion_obras_equip"
									//EX 20-09-2026 (fase 2 - paso 5): este value lo pasaba solo la edicion.
									value={valorInicial(csp_17_descripcion_obras_equip)}
									onChange={e => onChange(e)}
								/>
								<label alt="Descripción obras de infraestructura financiadas" for="id_csp_17">Descripción Obras de Infraestructura financiadas</label>
							</div>
						</div>
					</div>{/*cierra ---> div_hidden3*/}

					{/* -----SEGUIMIENTO cambios  ----*/}
					<div className="container_left">
						<h6 className="mt-4 text-left subtitulos">SEGUIMIENTO DE OBRAS Y EDIFICACIÓN</h6>
					</div>
					<div className="container_left">{/*---> container_left*/}
						<div className="input-container">
							<SelectInput
								name="csp_28_presencia_apertura_calles"
								id="id_csp_28"
								//EX 20-09-2026 (fase 2 - paso 5): este defaultValue lo pasaba solo la edicion.
								defaultValue={valorInicial(csp_28_presencia_apertura_calles)}
								options={optionsSeguimientoCSP}
								className="form-control my-3"
								onChange={e => onChange(e)}
							/>
							<label alt="Presencia de apertura de calles" for="id_csp_28">Presencia de apertura de calles</label>
						</div>
					</div>

					<div className="container_left">{/*---> container_left*/}
						<div className="input-number-45">
							{/*EX 20-09-2026 (fase 2 - paso 5): este value lo pasaba solo la edicion; con
							    precargarDatos = false el input queda no controlado, igual que en el alta.*/}
							<input title="Parcelas edificadas" type="number" name="csp_29_parc_edificadas" id="id_parc_edificadas_csp_29" value={valorInicial(csp_29_parc_edificadas)} onChange={e => onChange(e)} /> {/*value={cantidad_lotes}*/}
							<label alt="Parcelas edificadas" for="id_parc_edificadas_csp_29">Parcelas edificadas</label>
						</div>
						<div style={{ width: "4%" }}></div>
						<div className="input-number-45">
							<input
								title="Porcentaje parcelas edificadas"
								id="id_csp_30"
								type="number"
								name="csp_30_porcentaje_parc_edificadas"
								step="0.01"
								value={csp_30_porcentaje_parc_edificadas}
								onChange={e => onChange(e)}
								disabled
							/>
							<label alt="Porcentaje parcelas edificadas" for="id_csp_30">Porcentaje parcelas edificadas</label>
						</div>{/*cierra ---> input-number-45 */}
					</div>
					<p align="left" style={mensajeError === true ? { height: "auto", fontSize: "0.9em", color: "red" } : { display: 'none' }}>ERROR: La cant. de parcelas edificadas no puede superar la cant.de lotes adjudicables ({lotesAdjudicables})</p>

					<div className="container_left" style={{ height: "auto" }}>{/*---> container_left*/}
						<div className="input-container">
							<textarea
								title="Observaciones sobre el seguimientos de obras y edificación"
								id="id_csp_31"
								type="text"
								maxLength="500"
								name="csp_31_observ_seguimiento_obras_y_edificacion"
								//EX 20-09-2026 (fase 2 - paso 5): este ref lo pasaba solo la edicion, pero nunca
								//se lee (.current no se usa en ningun flujo), asi que es inerte en los dos.
								//EX 20-09-2026 (fase 2 - paso 5): este value lo pasaba solo la edicion.
								value={valorInicial(csp_31_observ_seguimiento_obras_y_edificacion)}
								onChange={e => onChange(e)}
								rows={5}
							/>
							<label alt="Observaciones sobre el seguimientos de obras y edificación" for="id_csp_31">Observaciones sobre el seguimientos de obras y edificación</label>
							<p align="right" style={{ height: "5px", fontSize: "0.9em" }}>Caracteres restantes: {maxObserv_31}</p>
						</div>
					</div>

					<div className="container_left">{/*---> container_left*/}
						<div className="input-number">
							<DatePicker
								id="id_csp_32"
								title="Fecha de control"
								name="csp_32_fecha_control_seguimiento_obras"
								dateFormat="MM/yyyy"
								className="form-control input_data_picker"
								selected={csp_32_fecha_control_seguimiento_obras}
								onChange={(date) => handleChangeDate({ name: "csp_32_fecha_control_seguimiento_obras", value: date })}
							/>
							<label alt="Fecha de control" for="id_csp_32">Fecha de control</label>
						</div>
					</div>

					{/* -----CENSO Y ADJUDICACIÓN cambios  ----*/}
					<div className="container_left">
						<h6 className="mt-4 text-left subtitulos">CENSO Y ADJUDICACIÓN</h6>
					</div>
					{/* Sección Censos */}
					<div className="mb-4">
						<h8 className="mt-4 text-left subtitulos">Censos</h8>
						{/*EX 20-09-2026 (fase 2 - paso 5): la edicion toleraba un censos nulo con (censos || [])
						    y el alta no. En el alta censos siempre es un array (ver el encabezado), asi que
						    queda la forma de la edicion: es un superconjunto y no cambia nada del alta.*/}
						{(censos || []).map((censo, index) => (
							<div key={index} className="container_left">
								<div style={{width: "43%"}} className="input-number">
									{/*EX 20-09-2026 (fase 2 - paso 5): la edicion normalizaba esta fecha antes
									    de pasarla a `selected` (capacidad normalizarFechasPrecargadas).*/}
									<DatePicker
										selected={fechaPrecargada(censo.fechaCenso)}
										onChange={(date) => handleCensoChange(index, "fechaCenso", date)}
										className="form-control input_data_picker"
										dateFormat="dd/MM/yyyy"
									/>
									<label>Fecha de censo:</label>
								</div>
								<div style={{width: "1%"}}/>
								<div style={{width: "43%"}} className="input-number">
									<input
										type="number"
										min="0"
										max="9999"
										className="form-control"
										value={censo.cantidadHogares}
										onChange={(e) => handleCensoChange(index, "cantidadHogares", e.target.value)}
									/>
									<label>Cantidad de hogares censados:</label>
								</div>
								<div style={{width: "1%"}}/>
								<div style={{width: "10%"}} className="col">
									<button
										type="button"
										className="btn btn-danger mt-1"
										onClick={() => handleRemoveCenso(index)}
										disabled={censos.length === 1}
									>
										Eliminar
									</button>
								</div>
							</div>
						))}
						<button type="button" className="btn btn-primary" onClick={handleAddCenso}>
							Agregar
						</button>
					</div>

					{/* Sección Boleto */}
					<div className="mb-4">
						<h8 className="mt-4 text-left subtitulos">Boleto de compra venta</h8>

						<div className="container_left">
							<div style={{width: "49.5%"}} className="input-number">								
								<input
									type="number"
									min="0"
									max="9999"
									className="form-control"
									name="entregados"
									value={boletos.entregados}
									onChange={handleBoletoChange}
								/>
								<label>Entregados:</label>
							</div>
							<div style={{width: "1%"}}/>
							<div style={{width: "49.5%"}} className="input-number">								
								<input
									type="number"
									min="0"
									max="9999"
									className="form-control"
									name="realizados"
									value={boletos.realizados}
									onChange={handleBoletoChange}
								/>
								<label>En condiciones de entrega:</label>
							</div>
						</div>	
						<div className="container_left">
							<div style={{width: "49.5%"}} className="input-number">								
								<input
									type="number"
									min="0"
									max="9999"
									className="form-control"
									name="enProceso"
									value={boletos.enProceso}
									onChange={handleBoletoChange}
								/>
								<label>En proceso de confección:</label>
							</div>
							<div style={{width: "1%"}}/>
							<div style={{width: "49.5%"}} className="input-number">								
								<input
									type="number"
									min="0"
									max="9999"
									className="form-control"
									name="enConflictoAdjudicatorio"
									value={boletos.enConflictoAdjudicatorio}
									onChange={handleBoletoChange}
								/>
								<label>En conflicto adjudicatorio:</label>
							</div>
						</div>
						<div className="container_left">
							<div style={{width: "49.5%"}} className="input-number">
								{/*EX 20-09-2026 (fase 2 - paso 5): idem fecha de censo (normalizarFechasPrecargadas).*/}
								<DatePicker
									className="form-control input_data_picker"
									dateFormat="dd/MM/yyyy"
									name="ultimaActualizacionBoletos"
									selected={fechaPrecargada(boletos.ultimaActualizacionBoletos)}
									onChange={(date) => handleBoletoDateChange( {name: "ultimaActualizacionBoletos", value: date} )}
								/>
								<label>Ultima actualización de boletos:</label>
							</div>
							<div style={{width: "1%"}}/>
							<div style={{ width: "49.5%" }} className="input-number">
								{/*EX 20-09-2026 (fase 2 - paso 5): idem fecha de censo (normalizarFechasPrecargadas).*/}
								<DatePicker
									className="form-control input_data_picker"
									dateFormat="dd/MM/yyyy"
									name="fechaEntregaBoletos"
									selected={fechaPrecargada(boletos.fechaEntregaBoletos)}
									onChange={(date) => handleBoletoDateChange( {name: "fechaEntregaBoletos", value: date} )}
								/>
								<label>Fecha de entrega de boletos:</label>
							</div>
						</div>
					</div>

					{/* Sección Trámites de escrituración */}
					<div className="mb-4">
						<h8 className="mt-4 text-left subtitulos">Trámites de escrituración</h8>

						<div className="container_left">
							<div style={{width: "49.5%"}} className="input-number">								
								<input
									type="number"
									min="0"
									max="9999"
									className="form-control"
									name="realizados"
									value={tramites.realizados}
									onChange={handleTramiteChange}
								/>
								<label>Realizados:</label>
							</div>
							<div style={{width: "1%"}}/>
							<div style={{width: "49.5%"}} className="input-number">								
								<input
									type="number"
									min="0"
									max="9999"
									className="form-control"
									name="enProceso"
									value={tramites.enProceso}
									onChange={handleTramiteChange}
								/>
								<label>En proceso administrativo:</label>
							</div>
						</div>
						<div className="container_left">
							<div style={{width: "49.5%"}} className="input-number">
								{/*EX 20-09-2026 (fase 2 - paso 5): idem fecha de censo
								    (capacidad normalizarFechasPrecargadas).*/}
								<DatePicker
									className="form-control input_data_picker"
									dateFormat="dd/MM/yyyy"
									name="ultimaActualizacionTramites"
									selected={fechaPrecargada(tramites.ultimaActualizacionTramites)}
									onChange={(date) => handleTramiteDateChange( {name: "ultimaActualizacionTramites", value: date} )}
								/>
								<label>Fecha última actualización:</label>							
							</div>
						</div>
					</div>
					{/* Sección Observaciones de censo */}
					<div className="mb-4">
						<h8 className="mt-4 text-left subtitulos">Observaciones al proceso de censo y  adjudicación</h8>
						<div className="container_left" style={{ height: "auto" }}>{/*---> container_left*/}
							<div className="input-container">
								<textarea
									title="Observaciones de censo"
									id="id_observaciones_censo"
									type="text"
									maxLength="500"
									name="observaciones_censo"
									//EX 20-09-2026 (fase 2 - paso 5): este value lo pasaba solo la edicion.
									value={valorInicial(observaciones_censo)}
									//onChange={e => onChange(e)}
									onChange={handleObservacionCensoChange}
									rows={5}
								/>
								
								<p align="right" style={{ height: "5px", fontSize: "0.9em" }}>Caracteres restantes: {maxObservCenso_36}</p>
							</div>
						</div>
					</div>

				</div>
			</div>
		</Fragment>
	)
};

export default Pestaña3_Exp;
